import { MessageContainer } from '@workday/upc-common';
import { toastActions } from './js/slices/toast.slice';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector, toastSelectors } from './js/store';

export function WclMessageContainer() {
    const messages = useAppSelector(toastSelectors.selectAll);

    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const messagesWithTranslations = messages.map(message => {
        const { type, text, translationKey } = message.data;

        let translated;
        if (translationKey) {
            translated =
                type === 'error'
                    ? t(
                          translationKey,
                          // @ts-ignore
                          {
                              ns: 'errors'
                          }
                      )
                    : t(
                          translationKey,
                          // @ts-ignore
                          {
                              ns: 'toast'
                          }
                      );
        }

        return {
            id: message.id,
            text: translated || text,
            type
        };
    });

    return (
        <MessageContainer
            messages={messagesWithTranslations}
            onClose={messageId => {
                dispatch(toastActions.clearMessage(messageId));
            }}
        />
    );
}
